import { NavLink } from "react-router-dom";
import { homeRoute } from "../../../base/constants/routeConstants";
import { ProjectModel } from "../../../base/models/projectModel";

interface Props {
  activeTab: number;
  setActiveTab: (idx: number) => void;
  selectedProject?: ProjectModel;
}

const LeftMenu = ({ activeTab, setActiveTab, selectedProject }: Props) => {
  return (
    <div className="h-full">
      <div className="inline-flex flex-row md:flex-col gap-2">
        <button
          onClick={() => {
            setActiveTab(0);
          }}
          className={`p-3 text-dark font-medium hover:opacity-60 ${
            activeTab === 0 ? "bg-indigo-300" : "bg-cardHoverColor"
          }`}
        >
          All Projects
        </button>

        <button
          onClick={() => {
            setActiveTab(1);
          }}
          className={`p-3 text-dark font-medium hover:opacity-60 ${
            activeTab === 1 ? "bg-indigo-300" : "bg-cardHoverColor"
          }`}
        >
          New Project
        </button>

        {selectedProject && (
          <button
            onClick={() => {
              setActiveTab(2);
            }}
            className={`p-3 text-dark font-medium hover:opacity-60 ${
              activeTab === 2 ? "bg-indigo-300" : "bg-cardHoverColor"
            }`}
          >
            Update Project
          </button>
        )}

        <NavLink
          to={homeRoute}
          className="p-3 text-dark font-medium hover:opacity-60 bg-cardHoverColor"
        >
          Back to site
        </NavLink>
      </div>
    </div>
  );
};

export default LeftMenu;
